<div>
  <div class="row">
    <div class="col-md-10">
      <canvas
        #canvas
        appDraw
        class="full-size center-block canvasheightwidth"
      ></canvas>
    </div>
    <div class="col-md-2 center-controls">
      <div class="row mb-2">
        <div class="col-md-6">
          <button class="rotate anti-clockwise" (click)="rotate(canvas, false)">
            <img src="assets/Keen&Wise_rotate L.png" />
          </button>
        </div>
        <div class="col-md-6 mb-2 mb-2">
          <button class="rotate clockwise" (click)="rotate(canvas, true)">
            <img src="assets/Keen&Wise_rotate R.png" />
          </button>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-md-6">
          <button class="flip vertical" (click)="flip(canvas, false)">
            <img src="assets/Keen&Wise_flip vertical.png" />
          </button>
        </div>
        <div class="col-md-6">
          <button class="flip horizontal" (click)="flip(canvas, true)">
            <img src="assets/Keen&Wise_flip horizontal.png" />
          </button>
        </div>
      </div>
      <div class="row">
        <button class="undo" (click)="undoLast(canvas)">Undo</button>
      </div>
      <div class="row">
        <button class="reset" (click)="reset()">Reset</button>
      </div>

      <div class="row">
        <div class="col-md-6"></div>
        <div class="col-md-6">
          <button class="save" (click)="save(canvas)">
            <img src="assets/Keen&Wise_save.png" />
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
